import ButtonGroup from 'react-bootstrap/ButtonGroup'

import LinkHelper from '@/components/Panels/LinkHelper/LinkHelper'
import useDirectories from '@/utils/useDirectories'

import styles from './NavigationPanel.module.scss'

type Props = {
  bracket?: string
  budget?: string
  disabled: boolean
  sanitized?: string
  tag?: string
}

const NavigationPanelBudget = ({ bracket, budget, disabled, sanitized, tag }: Props) => {
  const { dir } = useDirectories()
  const baseLink = `/${dir}/${sanitized}${bracket ? `/${bracket}` : ''}${tag ? `/${tag}` : ''}`
  return (
    <div>
      <div className={styles.navigationTitle}>Budget</div>
      <ButtonGroup className={styles.navigationButtons} size='sm'>
        <LinkHelper href={baseLink} primary={budget === undefined} scroll={false}>
          Any
        </LinkHelper>
        <LinkHelper disabled={disabled} href={baseLink + '/budget'} primary={budget === 'budget'} scroll={false}>
          $
        </LinkHelper>
        <LinkHelper disabled={disabled} href={baseLink + '/expensive'} primary={budget === 'expensive'} scroll={false}>
          $$$
        </LinkHelper>
      </ButtonGroup>
    </div>
  )
}

export default NavigationPanelBudget
